 export const obtenerFechaAgenda = (fecha) => {

  if (!fecha) {
    return {
      dia: "",
      mes: "",
      fechaCompleta: "",
    };
  }

  // Evitamos problemas de zona horaria
  const [anio, mes, dia] = fecha.split("-");

  const fechaObj = new Date(
    Number(anio),
    Number(mes) - 1,
    Number(dia)
  );

  const nombreMes = fechaObj.toLocaleDateString(
    "es-CL",
    {
      month: "long",
    }
  );

  const fechaCompleta = fechaObj.toLocaleDateString(
    "es-CL",
    {
      day: "numeric",
      month: "long",
      year: "numeric",
    }
  );

  return {
    dia,
    mes: nombreMes.toLowerCase(),
    fechaCompleta,
  };
};